import {ApolloClient} from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {createHttpLink} from 'apollo-link-http';

export default ({prefix, siteContext}) => {
    const cache = new InMemoryCache().restore();
    const linkHeaders = {
        'client-name': 'landingapp',
        'client-version': '1.0.0',
        'x-homeaway-site': `${siteContext.name}`,
        // Adding `x-csrf-token` for XHR queries when users are logged in
        'x-csrf-token': window.ha.csrfToken
    };

    return new ApolloClient({
        ssrMode: true,
        cache,
        link: createHttpLink({
            uri: `${prefix}/graphql`,
            credentials: 'same-origin',
            headers: linkHeaders
        })
    });
};
